/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Subscription { 
    id: number;
    tenantId: number;
    payingUserId?: number | null;
    createdAt: string;
    nextPaymentAt: string;
    isActive: boolean;
    planConfigurationId: number;
}

